import { render } from "./StyleguideHttp.pug?vue&type=template&id=112c83ba&lang=pug"
import script from "./StyleguideHttp.js?vue&type=script&lang=js"
export * from "./StyleguideHttp.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__